/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Privacy_Technical_DataInputs */

const fr_legal_privacy_technical_data = /** @type {(inputs: Legal_Privacy_Technical_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données techniques anonymisées (navigateur, système d'exploitation, type de terminal)`)
};

const en_legal_privacy_technical_data = /** @type {(inputs: Legal_Privacy_Technical_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anonymized technical data (browser, operating system, device type)`)
};

/**
* | output |
* | --- |
* | "Anonymized technical data (browser, operating system, device type)" |
*
* @param {Legal_Privacy_Technical_DataInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_privacy_technical_data = /** @type {((inputs?: Legal_Privacy_Technical_DataInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Privacy_Technical_DataInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_privacy_technical_data(inputs)
	return en_legal_privacy_technical_data(inputs)
});